import { createSelector } from 'reselect';
import type { RootState } from '../store';

export const selectStressLevelLabels = (state: RootState) => state.stressLevel.labels;

export const selectStressLevelData = (state: RootState) => state.stressLevel.data;

export const selectAverageStressLevel = createSelector([selectStressLevelData], (data) => {
  if (data.length === 0) return 0;
  const sum = data.reduce((acc, value) => acc + value, 0);
  return sum / data.length;
});
